<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-checkbox-group
        v-model="Promo.promoTargetCart.boundary.boundaryType"
        style="width: 100%"
      >
        <template v-for="(formcheck, idx) in formCheck">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-checkbox :label="formcheck.value" class="mt-2">{{
                formcheck.label
              }}</el-checkbox>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="flex-wrap: wrap"
                >
                  <template v-for="(form, idx) in formcheck.form">
                    <el-col
                      :span="form.span"
                      style="margin-bottom: 18px"
                      :key="idx"
                    >
                      <el-input
                        v-if="
                          (form.type == 'text' ||
                            form.type == 'password' ||
                            form.type == 'number') &&
                            (formcheck.value === 'qty' ||
                              formcheck.value === 'value')
                        "
                        v-model="
                          Promo.promoTargetCart.boundary[formcheck.value][
                            form.id
                          ]
                        "
                        :placeholder="form.placeholder"
                        :type="form.type"
                        @focus="e => onFocusText(e, formcheck.value, form.id)"
                        @blur="e => onBlurNumber(e, formcheck.value, form.id)"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-input
                        v-else-if="
                          form.type == 'text' ||
                            form.type == 'password' ||
                            form.type == 'number'
                        "
                        v-model="Promo.promoTargetCart.boundary[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetCart.boundary[form.id]"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                        :disabled="disabledField(formcheck.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                        <el-row
                          v-if="form.loadMore"
                          type="flex"
                          justify="center"
                        >
                          <el-button
                            :loading="form.onLoading"
                            size="mini"
                            round
                            @click="form.loadMore"
                            >Load More</el-button
                          >
                        </el-row>
                      </el-select>
                    </el-col>
                    {{ form.satuan }}
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-checkbox-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { thousandSeprator, unThousandSeprator } from "@/helpers";

export default {
  props: ["Promo"],
  data() {
    return {
      limitPaymentType: 25,
      limitBranch: 25,
      limitProvince: 25,
      limitRegencies: 25,
      limitDistricts: 25,
    };
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.paymentType.paymentTypes,
      branchs: state => state.branch.branchs,
      provinces: state => state.area.provinces,
      regencies: state => state.area.regencies,
      districts: state => state.area.districts
    }),
    formCheck() {
      let paymentTypeDTO = []
      this.paymentTypes.data.map(item => {
        if (['OD-CASH', 'OD-GIRO', 'OD'].includes(item.paymentCode)) {
          if (!paymentTypeDTO.find(x => x.name === 'Cash On Delivery')) {
            paymentTypeDTO.push({
              name: 'Cash On Delivery',
              value: 'OD'
            })
          }
        } else if (['CR CASH', 'CR GIRO', 'CR', 'CN'].includes(item.paymentCode)) {
          if (!paymentTypeDTO.find(x => x.name === 'TOP')) {
            paymentTypeDTO.push({
              name: 'TOP',
              value: 'CR'
            })
          }
        }
        return [];
      });
      paymentTypeDTO.push({
        name: 'Bank Transfer',
        value: 'BT'
      })
      paymentTypeDTO.push({
        name: 'Payment Gateway',
        value: 'PG'
      })
      return [
        {
          label: "UOM",
          value: "uom",
          form: [
            {
              type: "text",
              id: "uom",
              label: "",
              placeholder: "Max",
              satuan: "Karton",
              span: 16,
              rules: []
            }
          ]
        },
        {
          label: "Qty",
          value: "qty",
          form: [
            {
              type: "text",
              id: "max",
              label: "",
              placeholder: "Max",
              satuan: "Karton",
              span: 16,
              rules: []
            },
            {
              type: "text",
              id: "min",
              label: "",
              placeholder: "Min",
              satuan: "Karton",
              span: 16,
              rules: []
            }
          ]
        },
        {
          label: "Value",
          value: "value",
          form: [
            {
              type: "text",
              id: "max",
              label: "",
              placeholder: "Max",
              rules: []
            },
            {
              type: "text",
              id: "min",
              label: "",
              placeholder: "Min",
              rules: []
            }
          ]
        },
        {
          label: "Payment Method",
          value: "paymentMethod",
          form: [
            {
              type: "select",
              id: "paymentMethod",
              label: "",
              rules: [],
              data: paymentTypeDTO.map(item => {
                return item;
              }),
              onSearch: this.onSearchPaymentTypes,
              onLoading: this.paymentTypes.isLoading
            }
          ]
        },
        {
          label: "Customer Class",
          value: "customerClass",
          form: [
            {
              type: "select",
              id: "customerClass",
              label: "",
              rules: [],
              data: [
                {
                  name: "Traditional Market",
                  value: "Traditional Market"
                },
                {
                  name: "Modern Market",
                  value: "Modern Market"
                },
              ]
            }
          ]
        },
        // {
        //   label: "Customer Type",
        //   value: "customerType",
        //   form: [
        //     {
        //       type: "select",
        //       id: "customerType",
        //       label: "",
        //       rules: [],
        //       data: [
        //         {
        //           name: "Customer Type 1",
        //           value: "customeType1"
        //         },
        //         {
        //           name: "Customer Type 2",
        //           value: "customerType2"
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   label: "RGM",
        //   value: "rgm",
        //   form: [
        //     {
        //       type: "select",
        //       id: "rgm",
        //       label: "",
        //       rules: [],
        //       data: [
        //         {
        //           name: "RGM 1",
        //           value: "rgm1"
        //         },
        //         {
        //           name: "RGM 2",
        //           value: "rgm2"
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          label: "Branch",
          value: "branch",
          form: [
            {
              type: "select",
              id: "branch",
              label: "",
              rules: [],
              data: this.branchs.data.map(item => {
                item.name = `${item.branchCode} - ${item.branch}`;
                item.value = item.branchCode;
                return item;
              }),
              loadMore: this.loadMoreBranch,
              onSearch: this.onSearchBranch,
              onLoading: this.branchs.isLoading
            }
          ]
        },
        {
          label: "Province",
          value: "province",
          form: [
            {
              type: "select",
              id: "province",
              label: "",
              rules: [],
              multiple: true,
              data: this.provinces.data.map(item => {
                item.name = `${item.province}`;
                item.value = item.name;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.provinces.isLoading
            }
          ]
        },
        {
          label: "Regency",
          value: "regency",
          form: [
            {
              type: "select",
              id: "regency",
              label: "",
              rules: [],
              multiple: true,
              data: this.regencies.data.map(item => {
                item.name = `${item.regency}`;
                item.value = item.regencyId;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.regencies.isLoading
            }
          ]
        },
        {
          label: "District",
          value: "district",
          form: [
            {
              type: "select",
              id: "district",
              label: "",
              rules: [],
              multiple: true,
              data: this.districts.data.map(item => {
                item.name = `${item.district}`;
                item.value = item.districtId;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.districts.isLoading
            }
          ]
        }
        // {
        //   label: "Wilayah",
        //   value: "regionIdn",
        //   form: [
        //     {
        //       type: "select",
        //       id: "wilayah",
        //       label: "",
        //       rules: [],
        //       data: [
        //         {
        //           name: "Wilayah 1",
        //           value: "wilayah1"
        //         },
        //         {
        //           name: "Wilayah 2",
        //           value: "wilayah2"
        //         }
        //       ]
        //     }
        //   ]
        // }
      ];
    }
  },
  methods: {
    ...mapActions({
      getPaymentTypes: "paymentType/GetPaymentTypes",
      getBranch: "branch/GetBranchs",
      getProvinces: "area/GetProvinces",
      getRegencies: "area/GetRegencies",
      getDistricts: "area/GetDistricts"
    }),
    disabledField(value) {
      return !this.Promo.promoTargetCart.boundary.boundaryType.includes(value)
    },
    onSearchPaymentTypes(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getPaymentTypes(option);
    },
    loadMorePaymentTypes() {
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory
        }
      };
      this.getPaymentTypes(option);
    },
    onSearchBranchs(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBranch(option);
    },
    loadMoreBranch() {
      this.limitBranch += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBranch
        }
      };
      this.getBranch(option);
    },
    onBlurNumber(e, field, subField) {
      if (field === 'value') {
        this.Promo.promoTargetCart.boundary[field][subField] = thousandSeprator(e.target.value)
      }
    },
    onFocusText(e, field, subField) {
      if (field === 'value') {
        this.Promo.promoTargetCart.boundary[field][subField] = unThousandSeprator(e.target.value)
      }
    }
  },
  watch: {
    'Promo.promoTargetItem.boundary.province': {
      handler: function (val) {
        this.getRegencies(val)
      },
      deep: true
    },
    'Promo.promoTargetItem.boundary.regency': {
      handler: function (val) {
        this.getDistricts(val)
      },
      deep: true
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getPaymentTypes(option);
    this.getBranch(option);
    this.getProvinces(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
